import { NumberInput, required } from "react-admin";
import { formatDecimal } from "components/CandidatesSettings/GradingScales/utils";
import GridItem from "./GridItem";

const CreditsInput = ({ source = "credits", md = 6 }) => (
  <GridItem md={md}>
    <NumberInput
      source={source}
      label="Кредити"
      fullWidth
      format={formatDecimal}
      validate={required("Полето е задължително.")}
      onWheel={e => e.target.blur()}
    />
  </GridItem>
);

export default CreditsInput;
